"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
var _reactRedux = require("react-redux");
var listingActions = _interopRequireWildcard(require("./listingModule"));
var termsActions = _interopRequireWildcard(require("../terms/termsModule"));
var _ListingDetails = _interopRequireDefault(require("./ListingDetails"));
var _userProfileModule = require("../userProfile/userProfileModule");
var _LoadingIndicator = _interopRequireDefault(require("../shared/LoadingIndicator"));
var _utils = require("../utils");
var _withRouter = require("../HOCs/withRouter");
var _withAppContext = require("../HOCs/withAppContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } // eslint-disable-line import/no-named-as-default
var Listing = /*#__PURE__*/function (_Component) {
  function Listing(props) {
    var _this;
    _classCallCheck(this, Listing);
    _this = _callSuper(this, Listing, [props]);
    _this.getListing = _this.getListing.bind(_this);
    _this.initListingAndTerms = _this.initListingAndTerms.bind(_this);
    _this.id = props.params.id;
    return _this;
  }
  _inherits(Listing, _Component);
  return _createClass(Listing, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _getListing;
      var fetchListingIfNeeded = this.props.fetchListingIfNeeded,
        getListing = this.getListing,
        initListingAndTerms = this.initListingAndTerms;
      if ((_getListing = getListing(this.id)) !== null && _getListing !== void 0 && _getListing.data) {
        initListingAndTerms();
      } else {
        fetchListingIfNeeded(this.id);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _prevProps$listing$th = prevProps.listing[this.id],
        _prevProps$listing$th2 = _prevProps$listing$th === void 0 ? {} : _prevProps$listing$th,
        prevData = _prevProps$listing$th2.data;
      if (!prevData) {
        this.initListingAndTerms();
      }
    }
  }, {
    key: "initListingAndTerms",
    value: function initListingAndTerms() {
      var _this$props = this.props,
        _this$props$listing$t = _this$props.listing[this.id],
        _this$props$listing$t2 = _this$props$listing$t === void 0 ? {} : _this$props$listing$t,
        _this$props$listing$t3 = _this$props$listing$t2.data,
        _this$props$listing$t4 = _this$props$listing$t3 === void 0 ? {} : _this$props$listing$t3,
        _this$props$listing$t5 = _this$props$listing$t4.core,
        _this$props$listing$t6 = _this$props$listing$t5 === void 0 ? {} : _this$props$listing$t5,
        clientOptInType = _this$props$listing$t6.clientOptInType,
        useCardsTermsInsteadOfLoa = _this$props$listing$t6.useCardsTermsInsteadOfLoa,
        _this$props$userPrefs = _this$props.userPrefs,
        _this$props$userPrefs2 = _this$props$userPrefs === void 0 ? {} : _this$props$userPrefs,
        userId = _this$props$userPrefs2.userId,
        _this$props$profile = _this$props.profile,
        _this$props$profile2 = _this$props$profile === void 0 ? {} : _this$props$profile,
        Role = _this$props$profile2.Role,
        fetchLOAStatus = _this$props.fetchLOAStatus,
        fetchLOAContent = _this$props.fetchLOAContent,
        fetchTermsStatus = _this$props.fetchTermsStatus,
        fetchTermStatusByType = _this$props.fetchTermStatusByType,
        isPublic = this.context.isPublic;
      if (clientOptInType) {
        if (clientOptInType === 'ADMIN') {
          if (userId && Role === 1) {
            if (useCardsTermsInsteadOfLoa) {
              fetchTermStatusByType('cards');
            } else {
              fetchLOAStatus(userId);
            }
          }
          fetchLOAContent();
        }
        if (isPublic && (0, _utils.canUseDOM)() && window.utag) {
          (0, _utils.sendPublicView)();
        }
        if (userId) {
          fetchTermsStatus(userId);
        }
      }
    }
  }, {
    key: "getListing",
    value: function getListing() {
      var _this$props2 = this.props,
        listing = _this$props2.listing,
        id = _this$props2.params.id;
      return listing[id];
    }
  }, {
    key: "getListingCanonicalLink",
    value: function getListingCanonicalLink() {
      var sanitizedHost = (0, _utils.sanitizeOriginalHost)(this.props.meta.originalhost);
      var currPath = this.props.location.pathname;
      var pathWithoutUrlListingId = currPath[currPath.length - 1] === '/' ? currPath.substring(0, currPath.lastIndexOf('/', currPath.lastIndexOf('/') - 1)) : currPath.substring(0, currPath.lastIndexOf('/'));
      return (0, _utils.getCanonicalLink)(sanitizedHost, "".concat(pathWithoutUrlListingId, "/").concat(this.props.params.id));
    }
  }, {
    key: "getPageTitle",
    value: function getPageTitle() {
      var listing = this.getListing();
      if (!listing || listing.readyState !== listingActions.LISTING_FETCHED) {
        return 'Listing';
      }
      return listing.data.localized.name;
    }
  }, {
    key: "renderListing",
    value: function renderListing() {
      var _this$props3 = this.props,
        userPrefs = _this$props3.userPrefs,
        terms = _this$props3.terms,
        offerings = _this$props3.offerings,
        profile = _this$props3.profile,
        category = _this$props3.category;
      var _this$props$listing = this.props.listing,
        localizedRegions = _this$props$listing.localizedRegions,
        localizedCountries = _this$props$listing.localizedCountries,
        errors = _this$props$listing.errors;
      var listing = this.getListing().data;
      return /*#__PURE__*/_react.default.createElement(_ListingDetails.default, {
        terms: terms,
        listing: listing,
        userPrefs: userPrefs,
        offerings: offerings,
        pod: profile ? profile.PodID : undefined,
        localizedRegions: localizedRegions,
        localizedCountries: localizedCountries,
        errors: errors,
        clearError: this.props.clearError,
        category: category
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        listingNotFound = _this$props4.meta.listingNotFound,
        context = _this$props4.context;
      var readyState = this.getListing() ? this.getListing().readyState : listingActions.LISTING_FETCHING;
      var listingIsLoaded = readyState === listingActions.LISTING_FETCHED || readyState === listingActions.LISTING_NOT_FOUND;
      var listingTitle = readyState === listingActions.LISTING_FETCHED ? this.getListing().data.localized.title : '';
      var metaTags = [{
        name: 'description',
        content: listingIsLoaded ? listingTitle : 'App Center Listing'
      }];
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !listingNotFound && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
        meta: metaTags,
        title: context.getTitle(this.getPageTitle()),
        link: this.props.meta.isPublic ? [{
          rel: 'canonical',
          href: this.getListingCanonicalLink()
        }] : undefined
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          minHeight: '550px'
        }
      }, /*#__PURE__*/_react.default.createElement(_LoadingIndicator.default, {
        isLoaded: listingIsLoaded
      }, readyState === listingActions.LISTING_FETCHED && this.renderListing()))));
    }
  }]);
}(_react.Component);
Listing.propTypes = {
  params: _propTypes.default.any,
  listing: _propTypes.default.object,
  context: _propTypes.default.shape({
    getTitle: _propTypes.default.func.isRequired
  }).isRequired,
  location: _propTypes.default.object,
  fetchTermsStatus: _propTypes.default.func.isRequired,
  fetchLOAStatus: _propTypes.default.func.isRequired,
  fetchLOAContent: _propTypes.default.func.isRequired,
  terms: _propTypes.default.shape({
    appcenterStatus: _propTypes.default.object,
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    ereceiptTerms: _propTypes.default.string,
    sharedInfoStatus: _propTypes.default.object
  }),
  userPrefs: _propTypes.default.object,
  meta: _propTypes.default.shape({
    listingNotFound: _propTypes.default.bool,
    originalhost: _propTypes.default.string,
    isPublic: _propTypes.default.bool
  }),
  fetchListingIfNeeded: _propTypes.default.func.isRequired,
  profile: _propTypes.default.shape({
    Role: _propTypes.default.number,
    PodId: _propTypes.default.number
  }),
  fetchTermStatusByType: _propTypes.default.func.isRequired
};
function mapStateToProps(state) {
  return {
    meta: state.meta,
    listing: state.listing,
    userPrefs: state.userPrefs,
    terms: state.terms,
    offerings: state.userProfile.offeringsEnabled,
    profile: state.userProfile.profile,
    category: state.listings.category
  };
}
var mapDispatchToProps = {
  fetchListingIfNeeded: listingActions.fetchListingIfNeeded,
  clearError: listingActions.clearError,
  fetchTermsStatus: termsActions.fetchTermsStatus,
  fetchLOAStatus: termsActions.fetchLOAStatus,
  fetchLOAContent: termsActions.fetchLOAContent,
  isAppCenterEnabledCheck: _userProfileModule.isAppCenterEnabledCheck,
  fetchTermStatusByType: termsActions.fetchTermStatusByType
};
var _default = exports.default = (0, _withRouter.withRouter)((0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Listing)));